// extracted by mini-css-extract-plugin
module.exports = {"button":"PaginationButton_button__zJ64h","left":"PaginationButton_left__3Dj13"};